var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"region-map region-map-wrapper"},[_c('e-chart-world-map',{attrs:{"height":"300px","data":_vm.regions,"fit-to-data":false,"split-key":_vm.splitKey},on:{"select":_vm.onMapSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }